import { useState, useRef } from 'react'

const nextCursor = (index, max) => (index + 1) % max

export default function (set) {
  const max = set.length - 1
  const setRef = useRef(set)
  const [cursor, updateCursor] = useState(Math.round(Math.random() * max))

  return [
    setRef.current[cursor],
    () => {
      updateCursor(nextCursor(cursor, max))
    },
  ]
}
